import { state as detailPreviewState } from './detail_preview';
import { state as formState } from './form';
import { state as listState } from './list';
import { state as printState } from './print';

export const states = [
  detailPreviewState.RemitosDetailPreviewState,
  formState.RemitosFormState,
  listState.RemitosListState,
  printState.RemitosPrintState,
];
